import { refreshAllActionStatsRoutine } from './actions'

export const refreshRemedialCounts = () => {
  window.reduxStore?.dispatch(refreshAllActionStatsRoutine())
}
